import React from 'react';

import { observer } from 'mobx-react';
import { MainWrapper } from 'legacyComponents/styled/lib';
import Projects from 'apps/projects';
import { useNoAuthRedirect, useClientStore } from 'apps/hooks';
import DocumentHead from 'legacyComponents/documentHead';

const ProjectsPage = observer(() => {
  const clientStore = useClientStore();
  const { activeSpace } = clientStore;

  useNoAuthRedirect();

  const title =
    activeSpace?.spaceType === 'INITIATIVE'
      ? `${activeSpace?.content?.title}'s Projects`
      : 'My Projects';

  return (
    <MainWrapper marginBottom='4em'>
      <DocumentHead title={title} />
      <Projects />
    </MainWrapper>
  );
});

export default ProjectsPage;
